import "./styles.scss"

import React, { useState } from "react"
import { Link } from "gatsby"
import { AnimatePresence, motion } from "framer-motion"
import clsx from "clsx"

import { useLocale } from "context/locale"

import { getLangName } from "./utils"

const LangSwitcher = () => {
  const { t, lang, langs_switcher } = useLocale()

  const formattedLangs = langs_switcher
    ?.filter(lang_switch => lang_switch.code !== lang)
    .map(lang_switch => ({
      label: lang_switch.code,
      href: lang_switch.href,
    }))

  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={clsx("lang-switcher", isOpen && "lang-switcher--open")}>
      <button
        className="lang-switcher__toggle"
        onClick={() => setIsOpen(prevOpen => !prevOpen)}
      >
        {getLangName(lang, lang)}
      </button>
      <AnimatePresence mode="wait">
        {isOpen && (
          <motion.div
            className="lang-switcher__dropdown"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ type: "tween", duration: 0.2 }}
          >
            {formattedLangs?.map(({ label, href }, index) => (
              <Link
                key={index}
                to={href ? href : t("/")}
                onClick={() => localStorage.setItem("preffered_lang", label)}
              >
                {getLangName(label, lang)}
              </Link>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default LangSwitcher
